import { trackEvent } from 'utils';
import { CART_STEPS_CATEGORIES, CART_ACTIONS, CART_TRACKING_LABEL } from '../constants/analytics';

export function trackBackButtonClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.CONTINUE_SHOPPING, CART_TRACKING_LABEL.click);
}

export function trackProceedButtonClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.PROCEED_TO_CHECKOUT, CART_TRACKING_LABEL.click);
}

export function trackPayPalExpressClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.PAYPAL_EXPRESS, 'click');
}

export function trackOpenOrder(): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, 'Warnung', 'OpenOrder');
}

export function trackPaynowClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, 'OpenOrder', 'Bezahlen');
}

export function trackDpoClick(activated: boolean): void {
  trackEvent(
    CART_STEPS_CATEGORIES.OVERVIEW,
    CART_ACTIONS.DPO,
    activated ? 'Aktiviert' : 'Deaktiviert',
  );
}

export function trackDpoInfoClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.DPO, 'Info-Layer');
}

export function trackVoucherButtonClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.VOUCHER, 'Start');
}

export function trackVoucherApply(code: string, success: boolean): void {
  const label = success ? `OK-${code}` : `Fehler-${code}`;
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.VOUCHER, label);
}

export function trackVoucherRemove(code: string): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.VOUCHER, `entfernt-${code}`);
}

export function trackArticleDelete(productId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.CLICK_DELETE, `${productId}`);
}

export function trackArticleDeleteConfirm(productId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.CONFIRM_DELETE, `${productId}`);
}

export function trackArticleDeleteCancel(productId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.CANCEL_DELETE, `${productId}`);
}

export function trackArticleQuantityIncrease(productId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.INCREASE_QUANTITY, `${productId}`);
}

export function trackArticleQuantityDecrease(productId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.DECREASE_QUANTITY, `${productId}`);
}

export function trackArticleEdit(productId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.CLICK_EDIT, `${productId}`);
}

export function trackArticleCopy(productId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.OVERVIEW, CART_ACTIONS.CLICK_COPY, `${productId}`);
}
